import './Axis.css';
export var axis = '_cn5p9c0-2-0-1';